var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.routeReady)?_c(_vm.currentFormComponent,{tag:"Component"}):_vm._e(),(_vm.showApiPanel)?_c('ApiPanel',{attrs:{"model":_vm.store}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }